
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.648 6.9h-2.989v1.774h2.989c.889 0 1.578.454 1.578.844v7.864c0 .39-.69.844-1.578.844H3.352c-.89 0-1.579-.454-1.579-.844V9.519c0-.391.69-.845 1.579-.845H6.34V6.901H3.352C1.472 6.9 0 8.05 0 9.519v7.863C0 18.85 1.472 20 3.352 20h11.296C16.528 20 18 18.85 18 17.382V9.519C18 8.05 16.527 6.9 14.648 6.9z"}}),_c('path',{attrs:{"d":"M6.376 4.42a.883.883 0 00.627-.26l1.11-1.11v9.021a.887.887 0 101.773 0V2.99l1.17 1.17a.884.884 0 001.254 0 .886.886 0 000-1.254L9.662.26A.883.883 0 009.037 0h-.014a.883.883 0 00-.626.26L5.749 2.905a.886.886 0 00.627 1.514z"}})])
          )
        }
      }
    